export default {
    title: '等候室',

    menu: {
        starDraw: '星星抽奖',
        seedLetter: '字根',
        recentResult: {
            label: '最近课堂结果',
            short: '最近<br/>课堂结果',
        },
    },

    studentInfo: {
        gradeFormat: '{grade}年级',
        logoutConfirm: {
            title: '退出登录',
            message: '确定要退出登录吗？',
        },
    },

    navigation: {
        toAvatars: '前往星星抽奖',
        toSeedLetter: '前往字根',
        toRecentResult: '前往最近课堂结果',
    },

    languageSetting: {
        menuLabel: '语言设置',
        title: '语言设置',
        description: '您可以选择在学习画面上帮助您的语言。',
    },
};
